var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrTableEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41746",
    "data-name": "Group 41746",
    transform: "translate(-1155 -288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451",
    transform: "translate(787 233)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(368 55)",
    fill: "#14b7dd",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5620",
    "data-name": "Group 5620",
    transform: "translate(-2384 -2014.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M3555,2313.4l2.6,2.6a.281.281,0,0,1,0,.4l-6.3,6.3-2.677.3a.561.561,0,0,1-.62-.62l.3-2.677,6.3-6.3a.283.283,0,0,1,.4,0Z",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M3559.671,2312.738l-1.407-1.408a1.13,1.13,0,0,0-1.593,0l-1.021,1.021a.283.283,0,0,0,0,.4l2.6,2.6a.281.281,0,0,0,.4,0l1.021-1.021A1.127,1.127,0,0,0,3559.671,2312.738Z",
    fill: "#76747f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrTableEditIcon);
export default __webpack_public_path__ + "static/media/TRTableEditIcon.b71dc0277e5a181d20b5a9b4938afd61.svg";
export { ForwardRef as ReactComponent };